import { Down as DownArrow, Up as UpArrow } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, useTheme } from '@mui/material';

interface PercentageIconProps {
  value: number;
}

const PercentageChange = (props: PercentageIconProps) => {
  const theme = useTheme();
  const { value } = props;

  const color = value <= 0 ? theme.palette.colors.positive[500] : theme.palette.colors.negative[500];
  const icon =
    value > 0 ? (
      <UpArrow style={{ width: '15px', height: '15px', color }} />
    ) : (
      <DownArrow style={{ width: '15px', height: '15px', color }} />
    );
  const formattedValue = value.toFixed(2) === 'Infinity' ? 'NA' : `${value.toFixed(2)}%`;

  return (
    <Box sx={{ ...flex.itemsCenter }}>
      {icon}
      <Box sx={{ color }}> {formattedValue}</Box>
    </Box>
  );
};

export default PercentageChange;
